import { Box, Button, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

const CHOICE_LETTERS = ["أ", "ب", "ج", "د", "ه", "و"];

const VideoQuickQuiz = ({ question, isOpen, onContinue }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    if (isOpen) setSelectedIndex(null);
  }, [isOpen, question]);

  if (!isOpen || !question) return null;

  const hasAnswered = selectedIndex != null;
  const selectedChoice = hasAnswered ? question.choices[selectedIndex] : null;
  const isCorrect = Boolean(selectedChoice?.is_correct);
  const correctChoice = question.choices.find((choice) => choice.is_correct);

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      zIndex="2000"
      bg="rgba(14, 31, 66, 0.88)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={{ base: "12px", md: "20px" }}
      overflow="auto"
    >
      <VStack
        bg="white"
        color="gray.800"
        borderRadius="12px"
        p={{ base: "16px", md: "24px" }}
        spacing="16px"
        w="100%"
        maxW="560px"
        maxH="100%"
        overflow="auto"
        align="stretch"
        dir="rtl"
      >
        <Text
          fontSize="13px"
          fontWeight="700"
          color="main_1"
          textTransform="uppercase"
          letterSpacing="0.04em"
          dir="ltr"
          textAlign="left"
        >
          Quick quiz
        </Text>
        <Text fontSize={{ base: "16px", md: "18px" }} fontWeight="700" lineHeight="1.7">
          {question.question}
        </Text>
        <VStack spacing="8px" align="stretch">
          {question.choices.map((choice, index) => {
            const isSelected = selectedIndex === index;
            const showCorrect = hasAnswered && choice.is_correct;
            const showWrong = hasAnswered && isSelected && !choice.is_correct;

            return (
              <Button
                key={`${choice.text}-${index}`}
                onClick={() => {
                  if (!hasAnswered) setSelectedIndex(index);
                }}
                justifyContent="flex-start"
                whiteSpace="normal"
                height="auto"
                py="12px"
                px="14px"
                borderWidth="1px"
                borderColor={
                  showCorrect ? "green.400" : showWrong ? "red.400" : "gray.200"
                }
                bg={showCorrect ? "green.50" : showWrong ? "red.50" : "gray.50"}
                color="gray.800"
                fontWeight="600"
                textAlign="right"
                _hover={{
                  bg: hasAnswered ? undefined : "orange.50",
                  borderColor: hasAnswered ? undefined : "orange.300",
                }}
                cursor={hasAnswered ? "default" : "pointer"}
              >
                <Text as="span" ml="8px" color="main_1">
                  {CHOICE_LETTERS[index] || index + 1}.
                </Text>
                {choice.text}
              </Button>
            );
          })}
        </VStack>
        {hasAnswered && (
          <Text
            fontWeight="700"
            color={isCorrect ? "green.600" : "red.600"}
            fontSize="15px"
          >
            {isCorrect
              ? "إجابة صحيحة"
              : `إجابة خاطئة. الإجابة الصحيحة: ${correctChoice?.text || ""}`}
          </Text>
        )}
        {hasAnswered && (
          <Button bg="main_1" color="white" onClick={onContinue} _hover={{ opacity: 0.9 }}>
            Continue watching
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default VideoQuickQuiz;
